import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import sortBy from 'lodash/sortBy';
import camelize from 'camelize';

import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import { isUserLoggedIn } from 'marketing-website/selectors';
import { HOST } from 'marketing-website/configs/urls';
import { API_PLANS } from 'marketing-website/constants/api';
import { fetchApi } from 'marketing-website/utils/fetch';

import BillingSwitch from '../../components/modules/Pricing/BillingSwitch';
import EnterpriseCard from '../../components/modules/Pricing/EnterpriseCard';
import PlanCard from '../../components/modules/Pricing/PlanCard';
import {
  MARVEL_PLANS,
  PLAN_LABEL_FREE,
  PLAN_LABEL_PRO,
  PLAN_LABEL_COMPANY,
  PLAN_LABEL_TEAM,
} from '../../components/modules/Pricing/constants/plans';

const buttonCaptions = {
  [PLAN_LABEL_FREE]: 'Start with Free',
  [PLAN_LABEL_PRO]: 'Choose plan',
  [PLAN_LABEL_COMPANY]: 'Start 7 day free trial',
  [PLAN_LABEL_TEAM]: 'Start 7 day free trial',
};

class Pricing extends Component {
  static propTypes = {
    isLoggedIn: PropTypes.bool,
  };

  static defaultProps = {
    isLoggedIn: false,
  };

  constructor() {
    super();

    this.state = {
      toggleYearlyPrice: true,
      plans: [],
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    // Fetch plans data from the Marvel backend
    fetchApi('GET', getPlanUrls()).then(plans => {
      const formattedPlans = camelize(plans);
      this.setState({ plans: formattedPlans });
    });
  }

  onChange() {
    this.setState({ toggleYearlyPrice: !this.state.toggleYearlyPrice });
  }

  getSlugUrl(slug, quantity, label) {
    if (label === PLAN_LABEL_FREE) return '/signup';
    const billingCycle = this.state.toggleYearlyPrice ? 'yearly' : 'monthly';
    const nextUrl = `/upgrade/plan/${slug}/billing-cycle/${billingCycle}/quantity/${quantity ||
      1}/`;
    if (this.props.isLoggedIn) {
      return `${nextUrl}`;
    }
    return `/signup?next=${nextUrl}`;
  }
  render() {
    const planLength = Object.keys(MARVEL_PLANS).length + 1;
    const { toggleYearlyPrice, plans } = this.state;
    let maxWidth = 1320;
    let breakPointClassName = 'breakPointL-width-20';
    if (planLength < 5) {
      breakPointClassName = 'breakPointL-width-25';
      maxWidth = 920;
    }

    if (!plans.length) {
      return null;
    }
    let hasTrackedCurrency = false;
    const sortedPlans = sortBy(plans, [
      function(plan) {
        const teamMembersCount = plan.teamMembers || 1;
        if (!hasTrackedCurrency) {
          if (window && window.heap) {
            window.heap.track('Marketing Site Paywall Viewed', {
              currency: plan.currency,
            });
            hasTrackedCurrency = true;
          }
        }
        return plan.priceMonthly * teamMembersCount;
      },
    ]);

    return (
      <PageWrap maxWidth={maxWidth}>
        <Spacing size="xl" position="bottom" type="margin">
          <BillingSwitch
            yearlyPriceShown={toggleYearlyPrice}
            onSwitch={this.onChange}
            discountValue={25}
          />
        </Spacing>
        <div className="display-flex grid--m cf flexWrap-wrap">
          {sortedPlans.map(plan => (
            <div
              key={plan.slug}
              className={`width-100 breakPointS-width-50 breakPointM-width-33 ${breakPointClassName}`}
            >
              <PlanCard
                availableFeatures={plan.availableFeatures}
                billingCycle={toggleYearlyPrice ? 'yearly' : 'monthly'}
                CTAText={buttonCaptions[plan.label]}
                currency={plan.currency}
                handleCTAClick={() => {
                  window.location.href = `${HOST}${this.getSlugUrl(
                    plan.slug,
                    plan.teamMembers,
                    plan.label
                  )}`;
                }}
                isCurrentPlan={false}
                isDowngradeToFree={false}
                monthlyPrice={divideBy100MultiplyByTeamMembers(
                  plan.priceMonthly,
                  plan.teamMembers
                )}
                priceBeforeDiscount={divideBy100MultiplyByTeamMembers(
                  plan.priceMonthly * 12,
                  plan.teamMembers
                )}
                subTitle={plan.subTitle}
                title={plan.title}
                yearlyPrice={divideBy100MultiplyByTeamMembers(
                  plan.priceYearly,
                  plan.teamMembers
                )}
                yearlyPricePerMonth={divideBy100MultiplyByTeamMembers(
                  plan.priceYearly / 12,
                  plan.teamMembers
                )}
              />
            </div>
          ))}
          <div
            className={`width-100 breakPointS-width-50 breakPointM-width-33 ${breakPointClassName}`}
          >
            <EnterpriseCard />
          </div>
        </div>
      </PageWrap>
    );
  }
}

function getPlanUrls() {
  let urlStrings = '';
  MARVEL_PLANS.forEach(plan => {
    urlStrings = `${urlStrings}${plan},`;
  });
  return `${API_PLANS}${urlStrings}/`;
}

function divideBy100MultiplyByTeamMembers(value, teamMembers) {
  return (value / 100) * (teamMembers || 1);
}

function mapStateToProps(state) {
  return {
    isLoggedIn: isUserLoggedIn(state),
  };
}

export default connect(mapStateToProps)(Pricing);



// WEBPACK FOOTER //
// ./src/pages/pricing/Pricing.js